import React from 'react';
import { 
  Box, 
  Typography, 
  Paper,
  List,
  ListItem,
  ListItemText,
  Switch,
  Divider
} from '@mui/material';

const Settings = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Settings
      </Typography>
      <Paper elevation={3} sx={{ p: 3 }}>
        <List>
          <ListItem>
            <ListItemText primary="Enable Notifications" />
            <Switch defaultChecked />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText primary="Dark Mode" />
            <Switch />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText primary="Auto Backup" />
            <Switch defaultChecked />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText primary="Email Alerts" />
            <Switch />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText primary="Two-Factor Authentication" />
            <Switch defaultChecked />
          </ListItem>
        </List>
      </Paper>
    </Box>
  );
};

export default Settings;